export default __webpack_public_path__ + "static/media/nipe.fa53ee05.png";